import { render, staticRenderFns } from "./SlotTypeSelectbox.vue?vue&type=template&id=6e0da08f"
import script from "./SlotTypeSelectbox.vue?vue&type=script&lang=js"
export * from "./SlotTypeSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports